 document.addEventListener('DOMContentLoaded', function () {
    const timer = document.getElementById('countdown-{{ section.id }}');
    if (!timer) return;

    const endDate = timer.getAttribute('data-end-date');
    if (!endDate) return;

    const daysEl = timer.querySelector('.days');
    const hoursEl = timer.querySelector('.hours');
    const minutesEl = timer.querySelector('.minutes');
    const secondsEl = timer.querySelector('.seconds');

    // Parse Shopify date safely
    const targetDate = new Date(endDate.replace(/-/g, '/')).getTime();

    if (isNaN(targetDate)) {
      console.error('Invalid countdown date:', endDate);
      return;
    }

    function pad(num) {
      return num.toString().padStart(2, '0');
    }

    function updateCountdown() {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        clearInterval(countdownInterval);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((distance / (1000 * 60)) % 60);
      const seconds = Math.floor((distance / 1000) % 60);

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }

    updateCountdown();
    const countdownInterval = setInterval(updateCountdown, 1000);
  });


       $(".gallery23").slick({
    speed: 5000,
		autoplay: true,
		autoplaySpeed: 0,
		cssEase: 'linear',
  arrows:false,
    slidesToShow: 5,
  	slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
  	centerMode: true,
    focusOnSelect: true,
    responsive: [
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
              }
            }
            ]
});